class CustomerSession extends HTMLElement {
  constructor() {
    super();
    this.loginExpire = 6; // 12; // in hours
    this.cookieName = 'customer_login_expire';
    this.isLoggedIn = this.dataset.loginState == 'true';
  }

  async connectedCallback() {
    if (!this.isLoggedIn) return;
    if (!this.getCookie(this.cookieName)) {
      this.setCookie(this.cookieName, this.loginExpire);
    }
    const customerExpireTime = parseInt(this.getCookie(this.cookieName));
    const timeNow = new Date().getTime();
    if (timeNow > customerExpireTime) {
      this.deleteCookie(this.cookieName);
      window.location.href = '/account/logout';
    } else {
      this.setCookie(this.cookieName, this.loginExpire);
    }
  }
  
  getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
  
  setCookie(cname, expire) {
    var date = new Date();
    date.setHours(date.getHours() + expire);
    var expireDate = new Date();
    expireDate.setFullYear(new Date().getFullYear() + 1);
    document.cookie = cname + "=" + date.getTime() + "; domain=" + window.location.host + "; expires=" + expireDate.toUTCString() + "; path=/";
  }
  
  deleteCookie(cname) {
    document.cookie = cname + "=0; domain=" + window.location.host + "; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
  }
}

customElements.define('customer-session', CustomerSession);